module.exports = __webpack_public_path__ + "static/media/Klavika_Bold.fbb4f7be.woff";